export default "__VITE_ASSET__0e24fd3e__"